import { PixoSpatial, PixoPt } from './Pixospatial';
// @ts-ignore
import { Map, Popup, LngLat } from '!mapbox-gl';
import { HoverAction, HoverHandler, HoverTarget, HoverTargetState } from './hover-target';
import { AnyHandler, SimpleTHandler } from '../types/@types/sl-v-types';
import { LayerApiService } from './api-services/layer-api.service';
import { CancellablePromise } from '../types/cancellable-promise';
import { LayersApiService, QueryPromise } from './api-services/layers-api.service';
import { SLMap } from './sl-map';
import { SLLayer } from './sl-layer';
import { IsSuppressing } from './extra-params';
import { SandboxMessengerService } from '../services/sandbox-messenger.service';
import { FeatureFilterService } from '../services/feature-filter.service';

export class SpatialTooltip {
  private hoverer: HoverTarget;
  private context: PixoSpatial;
  private map: Map;
  private tooltip: Popup;
  public tooltipOn: boolean;
  private loading = false;
  private handler: AnyHandler;
  private query: QueryPromise;
  private slMap: SLMap;
  private inMap: boolean = false;
  private sbMsgr: SandboxMessengerService
  private filterService?: FeatureFilterService;
  private _maxRid = -1;
  constructor(slMap: SLMap) {
    this.slMap = slMap;

  }
  private _mouseMoveHandler: (event: MouseEvent) => void;
  SetFilterService(filterService: FeatureFilterService) {
    this.filterService = filterService;
  }
  SetMap(context: PixoSpatial, map: Map, handler: AnyHandler = null) {
    this.map = map;
    this.context = context;
    this.tooltipOn = false;
    this.tooltip = new Popup({
      closeButton: false,
      closeOnClick: false,
      closeOnMove: true
    });
    this._mouseMoveHandler = (event: MouseEvent) => {
      if (!!this.query) {
        this.query.promise.abort();
        delete this.query;
      }
      this.tooltip.getElement().removeEventListener('mousemove', this._mouseMoveHandler)
      this.tooltip.remove();
    }

    this.tooltip.getElement()?.addEventListener('mousemove', this._mouseMoveHandler);
    //this.slMap.SendSandboxMessage('hide-tooltip', {});

    this.handler = handler;
    this.hoverer = new HoverTarget(1250);
    /*map.on('idle',()=>{
      if(this.tooltipOn == false) return;
      this.slMap.SendSandboxMessage('hide-tooltip', { })
    });*/

  }
  private _timeout;
  Start() {
    if (!this.hoverer) {
      return;
    }
    this.tooltip.getElement()?.addEventListener('mousemove', this._mouseMoveHandler);
    this.hoverer.Watch(this.map.getCanvas(), (target, event: { x: number, y: number }, state: HoverAction) => {

      if (!!this.query) {
        this.query?.promise?.abort();
        delete this.query;
      }
      const layers = this.slMap.layerListService.GetHoverTipLayers(this.slMap.layers);
      if (!layers) return;
      if (layers?.length === 0) {
        this.query?.promise?.abort();
        delete this.query;
        return;
      }
      switch (state) {
        case 'cancelled':

          this.slMap.SendSandboxMessage('hide-tooltip', {});
          break;
        case 'hovered':
          /*if (this.inMap === false) {
            this.tooltip.remove();
            return;
          }*/
         const rid = ++this._maxRid;
          console.log('watch hovered');
          const pt: PixoPt = this.context.PixoPt(event);
          const lngLat: mapboxgl.LngLatLike = this.context.PixoSpatialCoord(pt).spatial as mapboxgl.LngLatLike;
          let progText = '<div class="progress tooltip-progress">';
          progText = progText + '<div class= "tooltip-progress-bar progress-bar progress-bar-animated progress-bar-striped" role = "progressbar" style = "width: 100%" aria-valuenow="100" aria-valuemin="100" aria-valuemax="100">Loading ...</div>';
          progText = progText + '</div>';
          this.tooltip.setLngLat(lngLat);
          this.loading = true;
          this.tooltipOn = true;

          this.query = this.slMap.component.layersAPI.QueryLayers(this.slMap, lngLat as LngLat, layers, 1,
            undefined, undefined, this.filterService?.ToJSON(), undefined, undefined, undefined);
          this.query?.promise?.then((response) => {
            if (!this.query) {
              if (this.tooltipOn === true) {
                this.tooltip.remove();
                this.tooltipOn = false;
              }
              return;
            }
            let layer: SLLayer;
            let feature: any;
            if (response.results.length === 0) {
              this.tooltip?.setHTML('<div class="tooltip-content"><div class="note-heading"><span class="far fa-comment-alt"></span> Note: </div>No results found</div>');
              this.slMap.SendSandboxMessage('hide-tooltip', {});
              return;
            }
            for (const resultLayer of response.results) {
              const lyr = this.slMap.GetLayerById(resultLayer.plid, true);
              if (lyr.filterField && (lyr.filterIds?.length == 0)) {
                for (const resultFeature of resultLayer.features) {
                  if (lyr.filterIds.indexOf(feature[lyr.filterField]) > -1) {
                    layer = lyr;
                    feature = resultFeature;
                  }
                }
              } else {
                layer = lyr;
                if (resultLayer.features.length > 0) {
                  feature = resultLayer.features[0];
                } else {
                  continue;
                }
              }
              if (!!layer && !!feature) {
                break;
              }
            }

            if (!layer && !response.results[0].plid) {
              layer = this.slMap.GetLayerById(response.results[0].layer, false);
              if (!layer) return;
              if (response.results[0].features.length > 0) feature = response.results[0].features[0];
            }

            if (!feature) {
              this.tooltip.setHTML('<div class="tooltip-content"><div class="note-heading"><span class="far fa-comment-alt"></span> Note: </div>No results found</div>');
            } else {

              if (!!this.slMap.src.extraParams.externalTooltip) {
                if (this._timeout) window.clearTimeout(this._timeout);
                this._timeout = window.setTimeout(() => {
                  if (response.results.length == 0) return;
                  if (response.results[0].features.length == 0) return;
                  if (this.tooltip) this.tooltip.remove();
                  if(rid < this._maxRid ) return;
                  this.slMap.SendSandboxMessage('show-tooltip', { rid: this._maxRid, layer: layer.identifier, feature: feature.gid, pt: { x: event.x, y: event.y } })
                  this.loading = false;
                }, 300)
                return;
              } else {
                const toolText = layer.GetTooltipText(feature, false);
                let note = '<div class="tooltip-note">Click the map for additional information at this location</div>';
                if (!!this.slMap.src.extraParams?.supressions) {
                  if (IsSuppressing(this.slMap.src.extraParams.supressions, 'query') && IsSuppressing(this.slMap.src.extraParams, 'query_vis_all')) {
                    note = '';
                  }
                }
                this.tooltip.setHTML(
                  '<div class="tooltip-content"><div class="note-heading"><span class="far fa-comment-alt"></span> Note: </div>' +
                  toolText + '</div>' + note);
              }
            }
            this.tooltip
              .addTo(this.map);
            this.loading = false;
          }, (_reason) => {
            if (this.tooltipOn === true) {
              this.tooltip.remove();
              this.tooltipOn = false;
            }
          });
          break;
        default:

      }
      if (this.handler !== null) {
        this.handler(this.tooltipOn);
      }
    });
  }
  Resume() {
    if (this.hoverer && this.hoverer.currentState === 'watching') {
      return;
    } else {
      this.Start();
    }
  }
  Stop() {
    if (this.hoverer) {
      this.hoverer.Clear();
    }
    this.slMap.SendSandboxMessage('hide-tooltip', {});
    if (this.tooltip) {
      //const tooltipElement = this.tooltip?.getElement();
      //tooltipElement?.removeEventListener('mousemove', this._mouseMoveHandler);

      this.tooltip?.remove();

    }
  }
  Remove() {
    this.hoverer.Clear();
    this.handler = null;
  }
  ToClientCoords(event: { x: number; y: number }) {
    const rect = this.map.getCanvas().getBoundingClientRect();
    const dpr = window.devicePixelRatio || 1;
    const looksDevice = event.x > rect.width + 2 || event.y > rect.height + 2;

    const xCss = looksDevice ? event.x / dpr : event.x;
    const yCss = looksDevice ? event.y / dpr : event.y;

    // viewport coords expected by Power BI
    let cx = rect.left + xCss;
    let cy = rect.top + yCss;

    // clamp so host never treats it as off-screen
    cx = Math.max(0, Math.min(window.innerWidth - 1, cx));
    cy = Math.max(0, Math.min(window.innerHeight - 1, cy));

    return { x: cx, y: cy };
  }
}
